import styles from './recipe-card.module.scss';
import React from "react";
import { Link } from "react-router-dom";

import CartButton from "../cart-button/cart-button";
import { Recipe } from "../../services/api";

export interface RecipeCardProps {
  name?: string;
  classes?: string;
  recipe: Recipe;
}

const slugify = (s: string) =>
  String(s)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

/**
 * Tarjeta de receta (nodo Figma `110:259`): contenedor navy, radio 30/30/30/200,
 * portada, botón "Ver receta", descripción, nombre y el **queso relevante**, que
 * es un botón para agregarlo al carrito (por cotizar).
 */
export default class RecipeCard extends React.Component<RecipeCardProps> {
  static jsClass = "RecipeCard";
  static defaultProps: Partial<RecipeCardProps> = {
    name: "mbRecipeCard",
  };

  render(): React.ReactNode {
    const { classes, recipe } = this.props;
    if (!recipe) return null;

    return (
      <article className={styles['mb-recipe-card'] + (classes ? ' ' + classes : '')}>
        <img
          className={styles['mb-recipe-card__img']}
          src={recipe.imagen}
          alt={recipe.titulo}
          loading="lazy"
        />
        <div className={styles['mb-recipe-card__body']}>
          <Link className={styles['mb-recipe-card__btn']} to={`/recetario/${recipe.slug}`}>
            Ver receta
          </Link>
          {recipe.descripcion && (
            <p className={styles['mb-recipe-card__copy']}>{recipe.descripcion}</p>
          )}
          <h3 className={styles['mb-recipe-card__title']}>{recipe.titulo}</h3>
          {recipe.producto && (
            <CartButton
              classes={styles['mb-recipe-card__sub']}
              item={
                recipe.productoRef
                  ? {
                      slug: recipe.productoRef.slug,
                      nombre: recipe.productoRef.nombre,
                      precio: recipe.productoRef.precio,
                      unidad: recipe.productoRef.unidad,
                      imagen: recipe.productoRef.imagen,
                    }
                  : {
                      slug: `queso-${slugify(recipe.producto)}`,
                      nombre: recipe.producto,
                      precio: 0,
                    }
              }>
              {recipe.producto}
            </CartButton>
          )}
        </div>
      </article>
    );
  }
}
